import api from './api';
import type { Doctor, Patient, PaginatedResponse } from '@/types';

export interface ListDoctorsParams {
  status?: string;
  search?: string;
  clinicId?: string;
  page?: number;
  limit?: number;
}

export interface CreateDoctorDto {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  clinicIds?: string[];
}

export const doctorsApi = {
  list: async (params: ListDoctorsParams = {}) => {
    const response = await api.get<PaginatedResponse<Doctor>>('/doctors', { params });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get<Doctor>(`/doctors/${id}`);
    return response.data;
  },

  create: async (dto: CreateDoctorDto) => {
    const response = await api.post<Doctor>('/doctors', dto);
    return response.data;
  },

  update: async (id: string, dto: Partial<CreateDoctorDto>) => {
    const response = await api.patch<Doctor>(`/doctors/${id}`, dto);
    return response.data;
  },

  search: async (q: string, limit?: number) => {
    const response = await api.get<Doctor[]>('/doctors/search', { params: { q, limit } });
    return response.data;
  },

  getPatients: async (id: string, params: { page?: number; limit?: number } = {}) => {
    const response = await api.get<PaginatedResponse<Patient>>(`/doctors/${id}/patients`, { params });
    return response.data;
  },

  associateWithClinic: async (id: string, clinicId: string) => {
    const response = await api.post<Doctor>(`/doctors/${id}/clinics`, { clinicId });
    return response.data;
  },

  removeFromClinic: async (id: string, clinicId: string) => {
    const response = await api.delete<Doctor>(`/doctors/${id}/clinics/${clinicId}`);
    return response.data;
  },
};

export default doctorsApi;
